'use strict'
import { serverApi } from '@/server';

export default {
    /**
     * 我的导出列表
     *
     * @author liu & 2019-7-4 14:54:51
     *
     * @method GET
     *
     * @url: /exports
     */
    exports(formData) {
        const url = '/exports';
        return serverApi.get(formData, url);
    },
    /**
     * 导出下载
     *
     * @author liu & 2019-7-4 14:54:51
     *
     * @method POST
     *
     * @url: /spa/exports-download
     */
    exportsDownload(formData,fileName) {
        const url = `/download-export`;
        return serverApi.downLoadByPost(formData, url, fileName,true);
    },
    /**
     * 发票记录队列导出
     *
     * @author liu
     *
     * @method POST
     *
     * @url /spa/invoices/excel/exports
     *
     * @returns {Promise}
     */
    invoicesExcelExports(formData) {
        const url = '/invoice/excel/exports'
        return serverApi.post(formData, url);
    },
    /**
     * 签约明细队列导出
     *
     * @author liu
     *
     * @method POST
     *
     * @url /spa/agreements/excel/exports
     *
     * @returns {Promise}
     */
    signRecordExcelExports(formData) {
        const url = '/agreements/excel/exports'
        return serverApi.post(formData, url);
    },
    /**
     * 签约批次队列导出
     *
     * @author liu
     *
     * @method POST
     *
     * @url /spa/sign-batches/excel/exports
     *
     * @returns {Promise}
     */
    bulkExcelExports(formData) {
        const url = '/sign-batches/excel/exports'
        return serverApi.post(formData, url);
    },
    /**
     * 打款明细队列导出
     *
     * @author liu
     *
     * @method POST
     *
     * @url /spa/pay-details/excel/exports
     *
     * @returns {Promise}
     */
    payDetailsExcelExports(formData) {
        const url = '/pay-details/excel/exports'
        return serverApi.post(formData, url);
    },
    /**
     * 打款明细队列导出
     *
     * @author liu
     *
     * @method POST
     *
     * @url /spa/pay-details/excel/exports
     *
     * @returns {Promise}
     */
     payDetailsAddExcelExports(formData) {
        const url = '/add-pay-details/excel/exports'
        return serverApi.post(formData, url);
    },
    /**
     * 打款异常队列导出
     *
     * @author liu
     *
     * @method POST
     *
     * @url /spa/pay-exception-details/excel/exports
     *
     * @returns {Promise}
     */
    payExceptionExcelExports(formData) {
        const url = '/pay-exception-details/excel/exports'
        return serverApi.post(formData, url);
    },
    /**
     * 打款批次队列导出
     *
     * @author liu
     *
     * @method POST
     *
     * @url /spa/pay-exception-details/excel/exports
     *
     * @returns {Promise}
     */
    payRecordExcelExports(formData) {
        const url = '/bulk-pay-records/excel/exports'
        return serverApi.post(formData, url);
    },
    /**
     * 个体信息队列导出
     *
     * @author liu
     *
     * @method POST
     *
     * @url /spa/individuals/excel/exports
     *
     * @returns {Promise}
     */
    individualExcelExports(formData) {
        const url = '/individuals/excel/exports'
        return serverApi.post(formData, url);
    },
    /**
     * 个体审核信息导出(待审核和审核记录)
     *
     * @author nick
     *
     * @param {Object} formData
     *
     *
     * @returns {Promise}
     *
     */
    individualAuditExcelExports(formData) {
        const url = `/individuals-audit/excel/exports`

        return serverApi.post(formData, url);
    },
    /**
     * 充值管理队列导出
     *
     * @author liu
     *
     * @method POST
     *
     * @url /spa/recharges/excel/exports
     *
     * @returns {Promise}
     */
    rechargesExcelExports(formData) {
        const url = '/recharges/excel/exports'
        return serverApi.post(formData, url);
    },
    /**
     * 商户用户队列导出
     *
     * @author liu
     *
     * @method POST
     *
     * @url /spa/users/excel/exports
     *
     * @returns {Promise}
     */
    merchantsManageExcelExports(formData) {
        const url = '/members/excel/exports'
        return serverApi.post(formData, url);
    },
    /**
     * 商户管理队列导出
     *
     * @author liu
     *
     * @method POST
     *
     * @url /spa/users/excel/exports
     *
     * @returns {Promise}
     */
    merchantsExcelExports(formData) {
        const url = '/merchants/excel/exports'
        return serverApi.post(formData, url);
    },
    /**
     * 商户管理-签约个体队列导出
     *
     * @author liu
     *
     * @method POST
     *
     * @url /spa/merchant-sign-individuals/excel/exports
     *
     * @returns {Promise}
     */
    signPeopleExcelExports(formData) {
        const url = '/merchant-sign-individuals/excel/exports'
        return serverApi.post(formData, url);
    },
    /**
     * 权限管理-用户管理队列导出
     *
     * @author liu
     *
     * @method POST
     *
     * @url /spa/users/excel/exports
     *
     * @returns {Promise}
     */
    userExcelExports(formData) {
        const url = '/users/excel/exports'
        return serverApi.post(formData, url);
    },
    /**
     * 通道管理-充值记录队列导出
     *
     * @author liu
     *
     * @method POST
     *
     * @url /spa/channel-deposit-records/excel/exports
     *
     * @returns {Promise}
     */
    channelsRechargeExcelExports(formData) {
        const url = '/channel-deposit-records/excel/exports'
        return serverApi.post(formData, url);
    },
    /**
     * 执照管理队列导出
     *
     * @author liu
     *
     * @method POST
     *
     * @url /spa/licenses/excel/exports
     *
     * @returns {Promise}
     */
    licenseExcelExports(formData) {
        const url = '/licenses/excel/exports'
        return serverApi.post(formData, url);
    },
    /**
	 * 监管信息导出
	 *
	 * @author nick
	 *
	 * @param {Number} id
	 *
	 *
	 * @returns {Promise}
	 *
	 */
    regulatoryInfoExport(formData) {
        const url = `/regulatory-information-export`

        return serverApi.post(formData, url);
    },
    /**
     * 代理商列表队列导出
     *
     * @author nick
     *
     * @method POST
     *
     * @url /merchant-agent/excel/exports
     * @param {Object} formData
     * @returns {Promise}
     */
    merchantAgentExcelExports(formData) {
        const url = '/merchant-agent/excel/exports'
        return serverApi.post(formData, url)
    },
    /**
     * 代理商用户列表队列导出
     *
     * @author nick
     *
     * @method POST
     *
     * @url /agent/excel/export
     * @param {Object} formData
     * @returns {Promise}
     */
    agentExcelExport(formData) {
        const url = '/agent/excel/export'
        return serverApi.post(formData, url)
    },
    /**
     * 返现队列导出
     *
     * @author wang & 2019-7-4 14:54:51
     *
     * @method POST
     * 
     * @url: /recharge-cashback-exports
     */
    rechargeCashbackExports(formData) {
        const url = `/recharge-cashback-exports`

        return serverApi.post(formData, url);
    },
}
